const environments = {
  local: "gestor_eventos",
  dev_server: "gestor_eventos",
  dev_gestorl: "a",
  prod_server: "",
};
const environment = process.env.REACT_APP_ADM_ENV;
const urlRoot = environments[environment];

const protocolo = window.location.protocol; //http
//const serv = window.location.hostname; //localhost
var rootGestor = "calendario.tec.mx/";
var rootApis = "admision.tec.mx";
var rootLandings = "admision.tec.mx/gestorl";


if (environment === "dev_server") {
  const hostDev = process.env.REACT_APP_HOST;
  rootGestor = hostDev + "/";
  rootApis = hostDev;
  rootLandings = hostDev + "/gestorl";
}


if (environment === "dev_gestorl") {
  const hostDev = process.env.REACT_APP_HOST;
  rootGestor = hostDev + "/";
  rootApis = hostDev;
  rootLandings = hostDev + "/gestorl";
}

if (environment === "local") {
  const hostDev = "localhost";
  rootGestor = hostDev + "/";
  rootApis = "10.97.85.129";
  rootLandings = "localhost:3000";
}

const apiUrlGestor = protocolo + "//" + rootGestor + urlRoot + "/api/";

var rootGestorl = rootLandings;
if (environment === "local") {
  rootGestorl = "10.97.85.129/gestorl";
}
const apiUrlGestorl = protocolo + "//" + rootGestorl + "/api/v1/";

const apiUrlLandings = protocolo + "//" + rootLandings + "/api/v1/eventos/";
const apiUrlAced = protocolo + "//" + rootApis + "/aced/api/directory/";
const apiUrlAcedOdd = protocolo + "//" + rootApis + "/aced/api/odd/";
const apiUrlSaveSpot = "https://admision.tec.mx/savespot/api/";
const SaveSpotGuarda = "prod"; // prod o dev
const apiCoreSave = protocolo + "//" + rootApis + "/coresave/";
const apiODD = protocolo + "//" + rootApis + "/odd/";

const YO_PROFESIONISTA_TIPO_EVENTO = "902107";
const YO_PROFESIONISTA_HUBSPOT_URL =
  "https://admision.tec.mx/YoProfesionista/pago/hubspot.php";

function enviarYoProfesionistaHubspot({
  email,
  nombre,
  apellidoPaterno,
  apellidoMaterno = "",
  claveEscuela,
  sexo = "SexoMasculino",
}) {
  const params = new URLSearchParams({
    email,
    clave_escuela: String(claveEscuela || ""),
    last_name: apellidoPaterno.replace(/ /g, "_"),
    first_name: nombre.replace(/ /g, "_"),
    apellido_materno: (apellidoMaterno || "").replace(/ /g, "_"),
    sexo,
  });

  return fetch(`${YO_PROFESIONISTA_HUBSPOT_URL}?${params.toString()}`)
    .then((response) => response.json())
    .then((data) => {
      console.log("YoProfesionista hubspot:", data);
      return data;
    })
    .catch((error) => {
      console.error("YoProfesionista hubspot:", error);
      return null;
    });
}

export {
  apiCoreSave,
  apiODD,
  apiUrlAced,
  apiUrlAcedOdd,
  apiUrlGestor,
  apiUrlGestorl,
  apiUrlLandings,
  apiUrlSaveSpot,
  SaveSpotGuarda,
  urlRoot,
  YO_PROFESIONISTA_TIPO_EVENTO,
  enviarYoProfesionistaHubspot,
};
